import { RootState } from '../../rootReducer';

export const readerSelectors = {
  getReaderData: (state: RootState) => state.ReaderState.readerData,
  getViewState: (state: RootState) => state.ReaderState.readerData.viewState,
  getDocumentControl: (state: RootState) => state.ReaderState.documentControl,
  getAnnotationListControl: (state: RootState) =>
    state.ReaderState.annotationListControl,
};
